import React from 'react';
import { Form, FormCheckProps } from 'react-bootstrap';

export type SwitchVaraintSize = 'sm' | 'md' | 'xl';

export type SwitchColorVariant = 'default' | 'gray' | 'blue-label';

export type SwitchProps = FormCheckProps & {
  label?: string;
  value?: string | number | boolean;
  className?: string;
  variant?: SwitchVaraintSize;
  isLeftLabel?: boolean;
  labelColor?: SwitchColorVariant;
};

const Switch = ({
  label,
  disabled,
  value,
  className,
  variant,
  onChange,
  onMouseDown,
  name,
  isLeftLabel = false,
  labelColor = 'default',
  ...props
}: SwitchProps) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    !disabled && onChange && onChange(event);
  };

  const handleOnMouseDown = (event: React.MouseEvent<HTMLInputElement>) => {
    event.preventDefault();
    onMouseDown && onMouseDown(event);
  };

  return (
    <Form.Check
      type={'switch'}
      className={`${className} ${labelColor} switch-custom ${
        variant ? ` switch-custom--${variant}` : ''
      } ${isLeftLabel ? 'label-left' : ''}`}
      value={value}
      disabled={disabled}
      onChange={handleOnChange}
      {...props}
      label={label && label}
      onMouseDown={handleOnMouseDown}
      name={name}
    ></Form.Check>
  );
};

export default Switch;
